export const NAME = 'sftp' as const;